import * as THREE from 'three'
import Experience from './Experience.js'

export default class Renderer
{
    constructor()
    {
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.camera = this.experience.camera

        this.isMobile = window.innerWidth < 768

        this.setInstance()
    }

    setInstance()
    {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: !this.isMobile,
            alpha: true
        })
        this.instance.toneMapping = THREE.CineonToneMapping
        this.instance.toneMappingExposure = 1.75
        this.instance.shadowMap.enabled = false
        this.instance.setClearColor(0x000000, 0)
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.isMobile ? 1 : this.sizes.pixelRatio)

        this.canvas.addEventListener('webglcontextlost', (e) =>
        {
            e.preventDefault()
        })

        this.canvas.addEventListener('webglcontextrestored', () =>
        {
            this.experience.needsUpdate = true
        })
    }

    resize()
    {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.isMobile ? 1 : this.sizes.pixelRatio)
    }

    update()
    {
        this.instance.render(this.scene, this.camera.instance)

        if(this.experience.world.bracelet && !this.experience.isFirstFrameReady)
        {
            this.experience.isFirstFrameReady = true
            window.parent.postMessage({ type: 'model-ready' }, '*')
        }
    }
}
